<template>
    <el-dialog
        :title="title"
        :visible.sync="DetaileddisShow"
        width="60%"
        :before-close="handleClose"
    >
        <el-row>
            <el-col :span="22" :offset="1">
                <div class="border-bottom margin-top2" style="padding-bottom: 10px;">
                    <el-button
                        v-for="(item,index) in ministryList"
                        :key="index"
                        @click="Ministry(item.name)"
                    >{{item.name}}</el-button>
                </div>
                <div style="overflow: hidden;padding: 10px 0;" class="border-bottom">
                    <div style="float: left;">
                        <span style="color: red;">订单号：</span>YT2001021272035928
                        <el-image
                            style="width: 20px; height: 20px;float: right;padding-left: 10px"
                            :src="url"
                            :preview-src-list="srcList"
                        ></el-image>
                    </div>
                    <div style="float: right;">
                        <span style="color: #0072ff;">处理：</span>2019.12.26
                    </div>
                </div>
                <div style="overflow: hidden;" class="margin-top2">
                    <div style="border-radius: 2px;border:1px #eee solid;">
                        <el-upload
                            action="https://jsonplaceholder.typicode.com/posts/"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove"
                        >
                            <i class="el-icon-plus" style="color: #0724ef;"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible" append-to-body>
                            <img width="100%" :src="dialogImageUrl" alt />
                        </el-dialog>
                        <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="textarea"></el-input>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
            <el-button @click="Cancellation">取 消</el-button>
            <el-button type="primary" @click="Determine">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: "FBMOrder",
    data() {
        return {
            DetaileddisShow: false,
            title: "",
            ministryList: [],
            dialogImageUrl: "",
            textarea: "",
            dialogVisible: false,
            url: require("../../../assets/imags/picture.png"),
            srcList: [
                "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
                "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg"
            ]
        };
    },
    mounted() {},
    methods: {
        init(content) {
            this.DetaileddisShow = true;
            this.title = content;
            if (this.title === "国际运单") {
                this.ministryList.push(
                    {
                        name: "未发货"
                    },
                    {
                        name: "已发货"
                    },
                    {
                        name: "已签收"
                    },
                    {
                        name: "运输途中"
                    },
                    {
                        name: "到达待取"
                    },
                    {
                        name: "投递失败"
                    },
                    {
                        name: "可能异常"
                    },
                    {
                        name: "运输过久"
                    }
                );
            } else if (this.title === "国内运单") {
                this.ministryList.push(
                    {
                        name: "待发货"
                    },
                    {
                        name: "已发货"
                    },
                    {
                        name: "已签收"
                    },
                    {
                        name: "运输途中"
                    },
                    {
                        name: "到达待取"
                    },
                    {
                        name: "投递失败"
                    },
                    {
                        name: "可能异常"
                    },
                    {
                        name: "运输过久"
                    }
                );
            }
        },
        Cancellation() {
            this.ministryList = [];
            this.DetaileddisShow = false;
        },
        Determine() {
            this.ministryList = [];
            this.DetaileddisShow = false;
        },
        handleClose() {
            this.ministryList = [];
            this.DetaileddisShow = false;
        },
        handleRemove(file) {
            console.log(file);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ {
    .el-textarea__inner:focus {
        outline: 0;
        border-color: #fff;
    }
    .el-textarea__inner {
        border: 1px solid #fff;
    }
    [class*=" el-icon-"],
    [class^="el-icon-"] {
        color: #fff;
    }
}
.addiconde {
    line-height: 55px;
    color: #0724ef;
}
</style>
